// extracted by mini-css-extract-plugin
export var assigneeBadge = "_jw-0";
export var assigneeDetails = "_jw-1";
export var assigneeInfo = "_jw-2";
export var dropdownContainer = "_jw-4";
export var dropdownImage = "_jw-5";
export var editAssigneeInfo = "_jw-3";
export var editAssigneeModalContainer = "_jw-6";
export var hidden = "_jw-8";
export var input = "_jw-7";